import { useEffect } from 'react';
import { useStore } from 'react-redux';

import { getFingerprint } from '../selectors/users';

export const useOnFingerprintCreate = (handler: (fp: string) => void) => {
  const store = useStore();

  useEffect(() => {
    let prevFp = getFingerprint(store.getState());

    if (prevFp === '-1') {
      let unsub: () => void;
      unsub = store.subscribe(() => {
        const fp = getFingerprint(store.getState());

        if (fp !== '-1' && prevFp !== fp) {
          prevFp = fp;
          handler(fp);
          unsub?.();
        }
      });
    } else {
      handler(prevFp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
